import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { BRAND } from '../data/mock';

export default function StickyCTAs() {
  return (
    <>
      {/* WhatsApp */}
      <a
        href={`https://wa.me/${BRAND.phoneRaw}?text=Hello%20Mondaine%20Style%2C%20I'd%20like%20to%20enquire%20about%20a%20consultation.`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp a stylist"
        className="fixed left-5 bottom-5 z-30 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform"
      >
        <MessageCircle size={22} />
      </a>

      {/* Sticky book button - mobile bottom */}
      <Link
        to="/book-consultation"
        className="lg:hidden fixed bottom-5 right-5 z-30 px-5 h-14 rounded-none bg-charcoal text-ivory flex items-center text-[11px] tracking-[0.22em] uppercase shadow-[0_10px_30px_-8px_rgba(0,0,0,0.5)] hover:bg-charcoal-soft transition-colors"
      >
        Book Consultation
      </Link>
    </>
  );
}
